export class SortWorkspaceBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "WorkspaceSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortWorkspaceBy.attributeTypeMap;
    }
    constructor() {
    }
}
